import orderBy from 'lodash/orderBy';
import { noResultsText } from 'utils/charts/constants';

export const marketAndTeamTop5ChartOptions = (rmData, titleText, type) => {
    const sortedRmData = orderBy(rmData, ['score'], ['asc']);
    const hasSortedRmData = sortedRmData && sortedRmData.length > 0;
    const categoryList = sortedRmData.map((rm) => rm.dimension);
    const seriesList = sortedRmData.map((rm) => rm.score);
    return {
        title: {
            left: 'left',
            text: titleText,
            textStyle: {
                color: '#244B60',
                fontSize: '12px'
            }
        },
        grid: {
            containLabel: true,
            width: '450px',
            height: '50%',
            left: hasSortedRmData ? '20px' : '40px',
            top: 'center'
        },
        xAxis: [
            {
                name:
                    type === 'market' ? 'Team Risk Score' : 'Total Risk Score',
                nameLocation: 'center',
                nameTextStyle: {
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12,
                    width: '100%',
                    verticalAlign: 'middle'
                },
                nameGap: 90,
                axisLine: {
                    show: false
                },
                axisLabel: {
                    show: false
                },
                splitLine: {
                    show: false
                }
            }
        ],
        yAxis: {
            type: 'category',
            data: categoryList,
            axisTick: {
                show: false
            },
            boundaryGap: false,
            axisLine: {
                show: seriesList.length > 0,
                lineStyle: {
                    color: '#E7E7E7'
                }
            },
            axisLabel: {
                color: '#929292',
                fontSize: '12px',
                fontWeight: 400,
                margin: 16
            }
        },
        series: [
            {
                type: 'bar',
                data: seriesList,
                label: {
                    show: true,
                    position: 'right',
                    fontSize: 10,
                    fontStyle: 'normal',
                    fontWeight: 400,
                    color: '#929292',
                    distance: 10
                },
                color: '#9BCEE2',
                stack: 'peer',
                stackStrategy: 'all',
                barWidth: 40,
                emphasis: {
                    focus: 'self',
                    blurScope: 'series'
                }
            }
        ],
        graphic:
            !sortedRmData || sortedRmData.length === 0 ? [noResultsText] : []
    };
};
